import { Injectable, OnDestroy, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';

// If the default title changes also update the title in index.html
const DEFAULT_TITLE = 'AGROLAB';

@Injectable({
  providedIn: 'root',
})
export class AlooraHeaderService implements OnDestroy {
  private readonly titleService = inject(Title);
  private dialog = inject(MatDialog);

  public newOrderButtonHidden = new BehaviorSubject<boolean>(false);
  private title: Subject<string> = new Subject();
  private _startTutorial$: Subject<void> = new Subject<void>();
  public startTutorial$: Observable<void> = this._startTutorial$.asObservable();
  private _showTutorial$: Subject<boolean> = new Subject<boolean>();
  public showTutorial$: Observable<boolean> = this._showTutorial$.asObservable();
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();
  public initialTutorial: boolean = true;
  constructor() {
    this.dialog.afterAllClosed
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.showTutorialButton());
    this.dialog.afterOpened
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.hideTutorialButton());
  }

  public setTitle(title: string) {
    this.titleService.setTitle(`${title || DEFAULT_TITLE} - ALOORA`);
    this.title.next(title || '');
  }

  public getTitle() {
    return this.title.asObservable();
  }

  public startTutorial() {
    this.initialTutorial = false;
    this._startTutorial$.next();
  }

  public hideTutorialButton() {
    this._showTutorial$.next(false);
  }

  public showTutorialButton() {
    this._showTutorial$.next(true);
  }

  public ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
